export default "__VITE_ASSET__DpUXz7mC__"